import Page from '../pages/model'
import api from '@/helpers/api'

export default {
    state: {

    },

    mutations: {

    },

    getters: {
        cpoList (state, getters) {
            return getters.query().get()
        },
    },

    actions: {
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'cpo.fetchItems')

            api.get('/api/v1/dictionaries/Cpo').then((res)=>{
                let data = []
                for (let i in res.data) {
                    if(res.data[i].type === 'direction') {
                        for (let j in res.data[i].children) {

                            if(res.data[i].children[j].type === 'dcs') {
                                for (let k in res.data[i].children[j].children) {

                                    if(res.data[i].children[j].children[k].type === 'cpo') {
                                        data.push({
                                            id: res.data[i].children[j].children[k].id,
                                            title: res.data[i].children[j].children[k].text,
                                            dcs: res.data[i].children[j].text,
                                            directorate: res.data[i].text,
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                store.dispatch('insertOrUpdate', { data: data })
                return data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'cpo.fetchItems')
            })
        },
    }
}
